package com.hyperether.goodjob.repository.remote.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class SetWorkspaceRequest(
    @SerialName("workspaceId") var workspaceId: String? = null
)